import React, { useState, useEffect } from 'react';
import { PrinterIcon } from '../../images/svgIcons';
import { Card } from './styles';
import { Empty } from 'antd';
import { fetchAllPrinters } from '../../utils/services/mailRoomAPI';
import Loader from '../../components/Loader';
import { RANDOM_COLORS } from '../../styles/variables';
import { withTranslation } from 'react-i18next';
import { MAIL_ROOM_PRINTER_LIST } from './translationValues';

const NAMESPACES=['MAIL_ROOM_PRINTER_LIST']

const PrinterList = ({
  selectedPrinter,
  setSelectedPrinter,
  printerSearchText,
  setSelectedPrinterName,
  isLoading,
  setIsLoading,
  t
}) => {
  const [printerList, setPrinterList] = useState([]);
  const [allPrinterList, setAllPrinterList] = useState([]);

  useEffect(() => {
    fetchPrinterList();
  }, []);

  useEffect(() => {
    filterPrinters(printerSearchText);
  }, [printerSearchText]);

  const fetchPrinterList = async () => {
    setIsLoading(true);
    const response = await fetchAllPrinters();
    if (response && response.errors && response.errors.length === 0) {
      if (response?.data && response?.data.length > 0) {
        setAllPrinterList(response?.data);
        setSelectedPrinter(response?.data[0]?.id);
        setSelectedPrinterName(response?.data[0]?.printerName);
        if (printerSearchText) {
          let filteredPrinters = response?.data.filter(printer => {
            return printer.printerName.toLowerCase().includes(printerSearchText.toLowerCase());
          });
          setPrinterList(filteredPrinters);
        } else {
          setPrinterList(response?.data);
        }
      }
      setIsLoading(false);
    }
  };

  const filterPrinters = searchName => {
    let filteredPrinters = allPrinterList.filter(printer => {
      return printer.printerName.toLowerCase().includes(searchName.toLowerCase());
    });
    setPrinterList(filteredPrinters);
    setSelectedPrinter(filteredPrinters[0]?.id);
    setSelectedPrinterName(filteredPrinters[0]?.printerName);
  };

  return (
    <>
      {isLoading ? (
        <Loader />
      ) : printerList?.length > 0 ? (
        printerList.map((li, key) => {
          return (
            <Card
              key={key}
              color={RANDOM_COLORS[key % RANDOM_COLORS.length]}
              selected={li.id === selectedPrinter}
              onClick={() => {
                setSelectedPrinter(li.id);
                setSelectedPrinterName(li.printerName);
              }}
              height={'140px'}
              width={'240px'}
              animation={true}
              animationDelay={key < 10 ? key * 200 + 'ms' : ''}
              justifyContent={'space-evenly'}
              cursorPointer={true}
            >
              <div className="printerIcon">{PrinterIcon()}</div>
              <div className="printerDetails">
                <p className="name">{li.printerName}</p>
                <p className="ipAddress">{li.printerIPAddress}</p>
              </div>
            </Card>
          );
        })
      ) : (
        <Empty description={t(MAIL_ROOM_PRINTER_LIST.NO_PRINTER_AVAILABLE_DESCRIPTION.key, MAIL_ROOM_PRINTER_LIST.NO_PRINTER_AVAILABLE_DESCRIPTION.value)} />
      )}
    </>
  );
};

export default withTranslation(NAMESPACES)(PrinterList);
